import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pictos/divers/picto_myifen_mobile.svg")